<app-loading [showText]="false" *ngIf="findOneByIdService.loading$ | async"></app-loading>
<app-summary-field *ngIf="documentSummary"
                   iconName="file" class="link">
    <a (click)="show()">{{label ? label : documentSummary.label}}</a>
    <app-document-download #documentDownload style="display: none;"
                           [entity]="documentSummary"></app-document-download>
    <span *ngIf="documentSummary.toBeSigned && !documentSummary.hasSignature">
        A signer
    </span>
    <span *ngIf="documentSummary.hasSignature">
        Signé
    </span>
    <app-loading [showText]="false" *ngIf="documentDownload.service.loading$ | async"></app-loading>
</app-summary-field>
